"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.reportWebPageOpen = exports.setWebClientIdPromise = exports.setTivTransactionIdPromise = void 0;
var logger_1 = require("../logger");
var __1 = require("../");
var log = (0, logger_1.getLogger)("reportWebPageOpen");
var tivTransactionIdPromise = Promise.resolve(undefined);
function setTivTransactionIdPromise(promise) {
    tivTransactionIdPromise = promise;
}
exports.setTivTransactionIdPromise = setTivTransactionIdPromise;
var webClientIdPromise = Promise.resolve(undefined);
function setWebClientIdPromise(promise) {
    webClientIdPromise = promise;
}
exports.setWebClientIdPromise = setWebClientIdPromise;
function reportWebPageOpen(props) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var urlSearchParams, event;
        var _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    urlSearchParams = new URLSearchParams(self.location.search);
                    _g = {
                        event_name: "WEB_PAGE_OPEN",
                        canonical_url: getCanonicalUrl(),
                        device_screen_width: screen.width,
                        device_screen_height: screen.height,
                        sc_referrer: (_a = urlSearchParams.get("sc_referrer")) !== null && _a !== void 0 ? _a : undefined,
                        utm_campaign: (_b = urlSearchParams.get("utm_campaign")) !== null && _b !== void 0 ? _b : undefined,
                        utm_content: (_c = urlSearchParams.get("utm_content")) !== null && _c !== void 0 ? _c : undefined,
                        utm_medium: (_d = urlSearchParams.get("utm_medium")) !== null && _d !== void 0 ? _d : undefined,
                        utm_source: (_e = urlSearchParams.get("utm_source")) !== null && _e !== void 0 ? _e : undefined,
                        utm_term: (_f = urlSearchParams.get("utm_term")) !== null && _f !== void 0 ? _f : undefined
                    };
                    return [4, tivTransactionIdPromise];
                case 1:
                    _g.tiv_transaction_id = _h.sent(),
                        _g.web_app_format = props.appFormat,
                        _g.notification_id = props.notificationId,
                        _g.notification_type = props.notificationType,
                        _g.source = props.source;
                    return [4, webClientIdPromise];
                case 2:
                    event = (_g.web_client_id = _h.sent(),
                        _g.page_id = props.pageId,
                        _g);
                    log.info("Logging WEB_PAGE_OPEN", event);
                    (0, __1.logEvent)(event);
                    return [2];
            }
        });
    });
}
exports.reportWebPageOpen = reportWebPageOpen;
function getCanonicalUrl() {
    return self.location.hostname;
}
//# sourceMappingURL=reportWebPageOpen.js.map